import axios, { AxiosResponse } from 'axios';
import { getEndpointBase } from '../../services/api.service';
import { TagListResponse } from '../ControlPanel/TagControl/TagControl.type';
import { TagSyncPayload } from './Tag.type';

let listRequest: any = null;

const tagService = {
  getList: ({search, ...params}: Record<string, string | number>): Promise<AxiosResponse<TagListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase('tag/list'), {
      params: {
        search,
        ...params
      }
    })
  },
  sync: (payload: TagSyncPayload): Promise<void> => {
    return axios.put(getEndpointBase('tag/sync'), payload)
  }
}

export default tagService;